import { apiClient } from "./fetch";
import { baseURL } from "../utils/constants";

// apiClient's instance baseURL is /api/v1; this endpoint lives under /api/v2.
// Passing an absolute URL overrides the instance baseURL (same trick the
// doctorQueueV2 actions use).
const baseURLV2 = baseURL.replace(/\/api\/v1\/?$/, "/api/v2");

export const exportBookingsExcel = async (params: {
  hospitalId: string;
  from: string;
  to: string;
}) => {
  return apiClient.get("/reports/export-bookings", {
    params,
    responseType: "blob",
  });
};

// One row of the booking export (POST /api/v2/booking-export).
// doctor_mapping_id / doctor_name are per-row so a multi-doctor export can be
// labelled by doctor on the FE.
export interface BookingExportRow {
  doctor_mapping_id?: string;
  doctor_name?: string;
  patient_name: string;
  patient_number: string;
  booked_date: string; // YYYY-MM-DD
  booking_time: string; // ISO timestamp
  visit_type: string; // "New" | "Follow-up"
  is_noshow?: boolean; // true = past booking, never checked in
}

// Booking export. Send a list of hospital-doctor mapping ids plus the date
// range in ONE call; the response is JSON rows ({ status, result: [...] }).
export const exportBookings = (body: {
  doctor_mapping_ids: string[];
  start_date: string;
  end_date: string;
}) => apiClient.post(`${baseURLV2}/booking-export`, body);
